import api from './api';
import { unwrapList, unwrapObject, type ListResult } from './api-envelope';
import type { AttributeListQuery, FilterableAttribute } from './queryKeys';
import type {
  AttributeType,
  CreateAttributeInput,
  UpdateAttributeInput,
} from '@erpgold/shared';

export const attributeService = {
  list: (params: AttributeListQuery): Promise<ListResult<AttributeType>> =>
    api.get('/attributes', { params }).then(unwrapList<AttributeType>),

  getByCode: (code: string): Promise<AttributeType> =>
    api.get(`/attributes/${code}`).then(unwrapObject<AttributeType>),

  create: (body: CreateAttributeInput): Promise<AttributeType> =>
    api.post('/attributes', body).then(unwrapObject<AttributeType>),

  update: (code: string, body: UpdateAttributeInput): Promise<AttributeType> =>
    api.put(`/attributes/${code}`, body).then(unwrapObject<AttributeType>),

  remove: (code: string): Promise<void> =>
    api.delete(`/attributes/${code}`).then(() => undefined),

  bulkRemove: (codes: string[]): Promise<{ deleted: number }> =>
    api.post('/attributes/bulk-delete', { codes }).then(unwrapObject<{ deleted: number }>),

  getFilterable: (): Promise<FilterableAttribute[]> =>
    api.get('/attributes/filterable').then(unwrapList<FilterableAttribute>).then((r) => r.data),
};
